// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-container__103Qq","error":"styles-error__3HxUz","btn_left":"styles-btn_left__3XZ0R","btn_right":"styles-btn_right__12pYy"};